<template>
    <div class="base-conhecimento text-start">
        <v-card variant="default"  class="pa-8 custom-border-card">
            <img class="mb-4" :src="require('@/ai_studio/assets/icons/logo-base-conhecimentos.svg')" alt="">
            <v-card-text color="neutral-35" class="pa-0">
                Confira nossos artigos que podem lhe ajudar a configurar o seu Rubeus Assistente:
                <div class="related-links-container mt-6 d-flex flex-column ga-4">
                    <a v-for="(link, index) in props.relatedLinks" :key="index" :href="link.link" target="_blank">
                        <div class="related-link elevation-1" >
                            {{ link.content }}
                        </div>
                    </a>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    relatedLinks: {
        type: Array,
        required: true,
        default: () => []
    }
});
</script>

<style scoped>
.base-conhecimento {
    max-width: 340px;
    margin-left: 75px;
    font-family: Roboto;
    color: rgb(var(--v-theme-neutral-35));
    padding-bottom: 10px;
}

.related-links-container a {
    color: rgb(var(--v-theme-neutral-35));
    text-decoration: none;
}

.related-link {
    font-family: Roboto;
    color: rgb(var(--v-theme-neutral-35));
    font-weight: 500;
    padding: 12px 16px 12px 24px;
    background-color: rgb(var(--v-theme-neutral-98));
    border-left: 4px solid rgb(var(--v-theme-primary-60));;
    border-radius: 0 8px 8px 0;
}

.custom-border-card {
  border: 1px solid rgba(0, 0, 0, 0.10);
  border-bottom: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

</style>